import { FILE_KEY_PRO_AVS } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.config';

export const FORM_ID_STRINGS = {
    [FILE_KEY_PRO_AVS]: {
        description: __('Votre certificat AVS est nécessaire à la validation de votre compte professionnel.'),
        skipLabel: __('Je transmets mon certificat plus tard')
    },
    default: {
        description: '',
        uploadDescription: '',
        skipLabel: __('Je transmets mon document plus tard'),
        skipWarning: '',
        skipWarningPro: `${__('Les délais d\'ouverture de compte pro seront plus longs.')} ${__('En l\'absence des justificatifs, vous posséderez un compte client particulier et ne pourrez pas bénéficier des avantages pro.')}`,
        skipWarningStudent: `${__('Les délais d\'ouverture de compte étudiant seront plus longs.')} ${__('En l\'absence des justificatifs, vous posséderez un compte client particulier et ne pourrez pas bénéficier des avantages étudiants.')}`
    }
};
